import type { ButtonProps } from '@chakra-ui/react';
import { HStack, Text } from '@chakra-ui/react';

import React from 'react';
import { ClipboardButton, ClipboardInput, ClipboardRoot } from '@/components/ui/clipboard';
import { Copy } from 'iconoir-react';

interface ClipboardCopyButtonProps extends ButtonProps {
  value: string;
  label?: string;
  icon?: React.ReactNode;
  successMessage?: string;
  hideIcon?: boolean;
}

export const ClipboardCopyButton: React.FC<ClipboardCopyButtonProps> = ({
  value,
  label = 'Copy',
  icon = <Copy width={16} height={16} />,
  successMessage,
  hideIcon = false,
  children,
  ...buttonProps
}) => {
  return (
    <ClipboardRoot value={value}>
      <ClipboardInput value={value} type="hidden" />
      <ClipboardButton {...buttonProps}>
        <HStack gap={2}>
          {!hideIcon && icon}
          {children || <Text>{label}</Text>}
        </HStack>
      </ClipboardButton>
    </ClipboardRoot>
  );
};
